module.exports = __webpack_public_path__ + "static/media/kehubaifangbaogao.063b5e10.png";